// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"styles_tabRow__Hba33","title":"styles_title__1vcyb"};